import { FunctionComponent, ReactNode } from 'react';
import { OnNext, OnPrev, OnExit, OnSubmit } from '../types';

export type RenderStep = (props: {
  forceShowError: boolean;
  setNextClickCount: (updater: (prev: number) => number) => void;
  resetNextClickCount: () => void;
  canContinue: boolean;
}) => ReactNode;

export type StepProps = {
  hideNextNavigation?: boolean;
  hidePrevNavigation?: boolean;
  hideExitNavigation?: boolean;
  canContinue?: boolean;
  onNext?: OnNext;
  onPrev?: OnPrev;
  onExit?: OnExit;
  onSubmit?: OnSubmit;
  prevButtonText?: string;
  nextButtonText?: string;
  submitButtonText?: string;
  loading?: boolean;
};

export const Step: FunctionComponent<StepProps & { children: RenderStep }> = ({
  children
  // eslint-disable-next-line react/jsx-no-useless-fragment
}) => <>{children}</>;
